import { z } from 'zod';
import { sectionHasValue } from '../util';
export const baseCardiovascularSchema = z.object({
    wnl: z.boolean().optional(),
    edemaLle: z.string().optional(),
    edemaRle: z.string().optional(),
    edemaType: z.string().optional(),
    pacemakerIcd: z.string().optional(),
    heartRate: z.string().optional(),
    capillaryLess: z.string().optional(),
    heartSounds: z.array(z.string()).optional(),
    heartSoundsDetail: z.string().optional(),
    cardiovascularNarrative: z.string().optional(),
    chestPainSinceLastVisit: z.string().optional(),
    chestPainWhen: z.string().optional(),
    chestPainProvocation: z.array(z.string()).optional(),
    chestPainProvocationOther: z.string().optional(),
    chestPainPalliation: z.array(z.string()).optional(),
    chestPainPalliationOther: z.string().optional(),
    nitroglycerinDoses: z.string().optional(),
    nitroglycerinTimeToRelief: z.string().optional(),
    chestPainQuality: z.array(z.string()).optional(),
    chestPainRadiation: z.string().optional(),
    chestPainRadiationDestination: z.string().optional(),
    chestPainSeverity: z.string().optional(),
    chestPainTiming: z.string().optional(),
    chestPainDuration: z.string().optional(),
    calledAnyone: z.array(z.string()).optional(),
    associatedSymptoms: z.array(z.string()).optional(),
    chestPainNewOrRecurrent: z.string().optional(),
    chestPainNow: z.string().optional(),
    chestPainNowSeverity: z.string().optional(),
    sobAtRest: z.string().optional(),
    weightToday: z.string().optional(),
    weightLastVisit: z.string().optional(),
    sacralEdema: z.string().optional(),
    edemaWorsening: z.string().optional(),
    orthopneaPillows: z.string().optional(),
    orthopneaWorsening: z.string().optional(),
    pndEpisodes: z.string().optional(),
    dpLeft: z.string().optional(),
    dpRight: z.string().optional(),
    ptLeft: z.string().optional(),
    ptRight: z.string().optional(),
    heartSoundsOther: z.string().optional(),
    dvtSymptoms: z.string().optional(),
    cardiacMedsTaken: z.string().optional(),
    medPartialReason: z.array(z.string()).optional(),
    medPartialReasonOther: z.string().optional(),
    medSideEffects: z.array(z.string()).optional(),
    medSideEffectsOther: z.string().optional(),
    educationTopics: z.array(z.string()).optional(),
    educationTopicsOther: z.string().optional(),
    patientUnderstanding: z.string().optional(),
    callUnderstanding: z.string().optional(),
    educationFollowUpPlan: z.string().optional(),
    cardiacStatus: z.string().optional(),
});
export const baseCardiovascularSchemaRefined = baseCardiovascularSchema.refine((data) => sectionHasValue(data), {
    message: 'Mark as within normal limits if none applies',
    path: [],
});
